import { Link } from "react-router";

export function Brand() {
  return <Link className="brand" to="/" aria-label="ほろりばレコード ホーム">
    <img src="/brand/logo-256-v3.png" width={44} height={44} alt="" />
    <span>ほろりば<span className="brand__record">レコード</span></span>
  </Link>;
}
